import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useProfile } from '../context/ProfileContext';

const { FiHome, FiFileText, FiTarget, FiList, FiBell, FiActivity, FiUsers, FiSettings, FiZap, FiUserCheck, FiRefreshCw } = FiIcons;

const Sidebar = () => {
  const { data } = useProfile();
  
  const navItems = [
    { path: '/', name: 'Dashboard', icon: FiHome },
    { path: '/optimizer', name: 'ATS Optimizer', icon: FiTarget },
    { path: '/profile-optimizer', name: 'Profile Optimization', icon: FiUserCheck },
    { path: '/base-resume', name: 'Base Resume', icon: FiFileText },
    { path: '/tracker', name: 'App Tracker', icon: FiList },
    { path: '/alerts', name: 'Job Alerts', icon: FiBell },
    { path: '/analytics', name: 'Analytics', icon: FiActivity },
    { path: '/community', name: 'Peer Review', icon: FiUsers },
  ];

  return (
    <div className="w-64 bg-gray-900 text-white h-screen fixed left-0 top-0 flex flex-col shadow-xl z-20">
      <div className="p-6 flex items-center gap-3 border-b border-gray-800">
        <div className="bg-blue-500 p-2 rounded-lg">
          <SafeIcon icon={FiTarget} className="text-xl text-white" />
        </div>
        <h1 className="text-xl font-bold tracking-wider">ATS-Pass</h1>
      </div>

      <nav className="flex-1 py-6 overflow-y-auto custom-scrollbar">
        <ul className="space-y-2">
          {navItems.map((item) => (
            <li key={item.name} className="px-4">
              <NavLink 
                to={item.path}
                className={({ isActive }) => 
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
                    isActive 
                      ? 'bg-blue-600 text-white shadow-md shadow-blue-500/20' 
                      : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                  }`
                }
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="font-medium text-sm">{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-gray-800 space-y-4">
        <NavLink to="/settings" className="block hover:bg-gray-800 p-2 rounded-xl transition-colors">
        <div className="flex items-center gap-3">
          {data.user.avatar_url ? (
            <img src={data.user.avatar_url} alt="Profile" className="w-10 h-10 rounded-full object-cover shadow-lg shrink-0" />
          ) : (
            <div className={`w-10 h-10 rounded-full bg-gradient-to-tr ${data.user.gradient} flex items-center justify-center text-white font-bold shadow-lg shrink-0`}>
              {data.user.initials}
            </div>
          )}
          <div className="overflow-hidden">
            <p className="text-sm font-medium truncate">{data.user.name}</p>
            <p className="text-[10px] text-gray-500 flex items-center gap-1">
              <SafeIcon icon={FiZap} className="text-yellow-500" /> Pro Plan
            </p>
          </div>
          <SafeIcon icon={FiSettings} className="ml-auto text-gray-500" />
        </div>
        </NavLink>
      </div>
    </div>
  );
};

export default Sidebar;